import { Address } from '@adornis/address/db/address.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity } from '@adornis/baseql/decorators.js';
import type { translationsMatching } from '@adornis/bh-matching-translation/translations.js';
import { ExportDataView } from '@adornis/data-view/db/export-data-view.js';
import type { Translator } from '@adornis/translation-core/translation.js';
import { DateTime } from 'luxon';

export const BUDDY_EXPORT_ENUM_FIELDS = [
  'gender',
  'genderPreference',
  'department',
  'preferredLanguage',
  'mentorSprache',
  'angestrebterAbschluss',
  'firstTime',
  'meetingType',
  'searchingWork',
  'firstGenerationStudent',
  'naechsteKarriereschritte',
  'menteeSemester',
  'extraSubject',
  'extraSubjectSonstiges',
  'mainSubject',
  'foreignLanguages',
  'privacyPolicy',
  'languageC1',
  'minSemesterPrerequisite',
  'immigrantHistory',
  'studiedAbroad',
  'erasmusStudent',
  'firstTime',
  'international',
  'goetheStudent',
  'abschlussarbeitBetreuen',
  'workIntegratedLeaning',
  'internationalMentees',
];
export const BUDDY_EXPORT_ENUM_LIST_FIELDS = ['whatIsNeededFromMentor', 'menteeDepartments'];
export const BUDDY_EXPORT_STRING_FIELDS = ['matrikelNummer', 'phoneNumber', 'phone', 'menteeSemester', 'birthday'];

@Entity()
export class BuddyExportDataView extends ExportDataView {
  static override _class = 'BuddyExportDataView';

  static override translateValue(field: string, value: any) {
    const translator = this._translator as Translator<typeof translationsMatching>;
    let translatedStr: Maybe<string> = null;

    if (value === null || value === undefined) return '';
    // nur mentee => mentorSprache, "profilbild"(id), "lebenslauf"(id)
    // nur mentor => menteeDepartments,
    // weitere =>, extraSubject, extraSubject, expectedGraduationMonth
    // müssen Boolean => minSemesterPrerequisite, extraSubjectSonstiges,

    if (!!value && typeof value === 'boolean') value = value ? 'JA' : 'NEIN';

    if (BUDDY_EXPORT_ENUM_FIELDS.includes(field) && !!value) translatedStr = translator.translate('enums', value);

    if (BUDDY_EXPORT_ENUM_LIST_FIELDS.includes(field) && !!value)
      translatedStr = (value as string)
        .split(', ')
        .map(curEnum => translator.translate('enums', curEnum))
        .join(', ');

    //if (field === 'academicDegree') return safeGetFirst(ACADEMIC_DEGREE, value);
    if (field === 'address' && !!value && typeof value === 'object') {
      const mabyeAdress = value as Maybe<Address>;
      if (mabyeAdress?._class === Address._class) {
        const zipCity = mabyeAdress.zipCity;

        const street = mabyeAdress['streetAndHousenumber']?.toString();
        const zip = zipCity?.['zip']?.toString();
        const city = zipCity?.['city']?.toString();

        translatedStr = [street, `${zip} ${city}`]
          .filter(str => !!str)
          .join(', ')
          .replaceAll('undefined', '')
          .replaceAll('null', '');
      }
    }
    //if (typeof value === 'boolean') return value[field] ? 'Wahr' : 'Falsch';
    if (value instanceof Date) {
      const valueAsDateTime = DateTime.fromJSDate(value);
      const formattedDate = valueAsDateTime.toLocaleString(
        field === 'birthday' ? DateTime.DATE_SHORT : DateTime.DATETIME_MED,
      );
      translatedStr = `${formattedDate}`;
    }

    if (BUDDY_EXPORT_STRING_FIELDS.includes(field) && !!value) translatedStr = `\t${translatedStr ?? value}`;

    if (!translatedStr) return super.translateValue(field, value);
    return translatedStr;
  }
}
